/** Close a socket without the browser warning when it never left CONNECTING. */
export function abandonWebSocket(ws: WebSocket | null | undefined): void {
  if (!ws) {
    return;
  }
  if (ws.readyState === WebSocket.CONNECTING) {
    ws.onopen = () => {
      ws.close();
    };
    return;
  }
  if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CLOSING) {
    ws.close();
  }
}
